angular.module('TetherApp').controller('ListController', [
    '$window',
    '$location',
    '$mdDialog',
    'listService',
    'clientService',
    '$mdMedia',
    function (
        $window,
        $location,
        $mdDialog,
        listService,
        clientService,
        $mdMedia
    ) {
        let self = this;
        self.currentList = {};

        self.delete = function (listId) {
            if ($window.confirm(self.deleteConfirmationText)) {
                listService.deleteList(listId)
                    .then(onDelete, onError);
            }
        };

        let onDelete = function () { window.location = window.location };

        self.broadcastPopup = function (ev, list) {
            self.currentList = list;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'broadcastPopupController',
                bindToController: true,
                templateUrl: '/list/partials/broadcast-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.createPopup = function (ev) {
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'createPopupController',
                bindToController: true,
                templateUrl: '/list/partials/create-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.managePopup = function (ev, list, isTethered) {
            self.currentList = list;
            if (isTethered === 1) {
                self.currentList.isTethered = 1;
            }
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'managePopupController',
                bindToController: true,
                templateUrl: '/list/partials/edit-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.manageTetheredPopup = function (ev, list, isTethered) {
            self.currentList = list;
            if (isTethered === 1) {
                self.currentList.isTethered = 1;
            }
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'managePopupController',
                bindToController: true,
                templateUrl: '/list/partials/edit-tethered-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.uploadParticipantsPopup = function (ev, list) {
            self.currentList = list;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'uploadParticipantsPopupController',
                bindToController: true,
                templateUrl: '/list/partials/upload-participants-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.addMemberPopup = function (ev, list) {
            self.currentList = list;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'addMemberPopupController',
                bindToController: true,
                templateUrl: '/list/partials/manage-participants-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.viewMemberPopup = function (ev, list, callback1) {
            self.currentList = list;
            self.viewMemberPopupCallback = callback1;
            self.viewMemberPopupEvent = ev;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'viewMemberPopupController',
                bindToController: true,
                templateUrl: '/list/partials/view-participants-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        self.delete = function(listId) {
            if ($window.confirm('Are you sure you want to delete this list?')) {
                listService.deleteList(listId)
                    .then(onSuccess, onError)
            }
        };

        let onSuccess = function () { window.location = window.location; };

        let onError = function(reason) {
            let message = 'Error occurred while deleting list\n\n';
            for (let index in reason.data.errors) {
                if (reason.data.errors.hasOwnProperty(index)) {
                    message += reason.data.errors[index] + '\n';
                }
            }
        };

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;
            dCtrl.message = undefined;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                window.location = window.location;
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };
        };

        self.isGreaterThanSmall = $mdMedia('gt-sm');
    }
]);
